import Phaser from 'phaser';

export class QuestionBlock extends Phaser.Physics.Arcade.Sprite {
  used = false;
  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y, 'question-block');
    scene.add.existing(this);
    scene.physics.add.existing(this, true);
    this.setDisplaySize(48, 48).setDepth(6);
    this.refreshBody();
  }

  activate(): void {
    if (this.used) return;
    this.used = true;
    this.setTexture('used-block');
    this.scene.tweens.add({ targets: this, y: this.y - 8, duration: 75, yoyo: true, ease: 'Quad.out', onUpdate: () => this.refreshBody() });
  }

  get underside(): number { return (this.body as Phaser.Physics.Arcade.StaticBody).bottom; }
}
